module.exports = __webpack_public_path__ + "static/img/icon-import.ee7aabe1.svg";